export const ATTACHMENT_TRANSLATION_UNSUPPORTED_REASONS = {
    NOT_PDF: 'not_pdf',
    SCANNED: 'scanned',
    TOO_LONG: 'too_long',
};
